<script>
  import { fade } from "svelte/transition";
  import { experience, viewport } from "@stores/global";
  import { FADE_DURATION } from "../consts";

  export let alt;
  export let src;

  const originalSrc = src;
  let srcset;
  let sizes;

  $: if (typeof originalSrc === "object") {
    const [arWidth, arHeight] = ($experience.aspectRatio || "16:9").split(":");
    ({sizes, src, srcset} = Object.entries(originalSrc)
      .sort(([a], [b]) => (a < b ? 0 : 1))
      .reduce(
        (attrs, [width, url], index, arr) => {
          const first = index === 0;
          const last = index === arr.length - 1;
          const separator = first ? "" : ", ";
          attrs.sizes = first
            ? `${Math.round($viewport.height * (arWidth / arHeight))}px`
            : attrs.sizes;
          attrs.srcset = `${attrs.srcset}${separator}${url} ${width}w`;

          if (last) {
            attrs.src = url;
          }

          return attrs;
        },
        {sizes: "", srcset: "", src: ""}
      )
    );
  }
</script>

<style>
  .poster {
    background-color: var(--background-color);
    height: 100%;
    left: 0;
    overflow: hidden;
    padding: 0 !important;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 3;
  }

  img {
    height: 100%;
    left: 50%;
    position: absolute;
    top: 0;
    transform: translateX(-50%);
    width: auto;
  }
</style>

<div class="poster" out:fade={{ duration: FADE_DURATION }}>
  <img {alt} {srcset} {sizes} {src} />
</div>
